module.exports = __webpack_public_path__ + "4f3feba296bfbbc51dd3e5baaad54563.pdf";